import type { ProjectSaveResponseSecurityCheckStatus } from './projectSaveResponseSecurityCheckStatus';

/**
 * 프로젝트 저장 응답
 */
export interface ProjectSaveResponse {
  /** 상태 메시지 */
  message?: string;
  /** 생성된 프로젝트 ID */
  projectId: string;
  /** 리디렉션 URL (프로젝트 상세 페이지) */
  redirectUrl?: string;
  /** 보안 검증 상태 (진행 중, 통과, 실패) */
  securityCheckStatus?: ProjectSaveResponseSecurityCheckStatus;
  /** 프로젝트 저장 성공 여부 */
  success: boolean;
}
